<template>
  <div class="Foot">
    <div class="foot1">
      <div class="contact w1200 clearfix">
        <div class="l">
          <img src="../../public/img/logo.png" alt="">
          <ul>
            <li>
              <img src="../../public/img/wx.png" alt="">
              <span>关注APM微信公众号</span>
            </li>
          </ul>
        </div>
        <div class="m">
          <div>产品功能</div>
          <ul class="">
            <li :class=" $route.path == '/' ? 'act' : ''" ><a href="javascript:;" @click="JumpToPage('')">首 页</a></li>
            <li :class=" $route.path == '/InsideCompany' ? 'act' : ''" ><a href="javascript:;" @click="JumpToPage('InsideCompany')">我在企业</a></li>
            <li :class=" $route.path == '/CompanyPanel' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('CompanyPanel')">企业面板</a></li>
            <li :class=" $route.path == '/SalesBusiness' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('SalesBusiness')">销售业务</a></li>
            <li :class=" $route.path == '/ProjectStart' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('ProjectStart')">项目实施</a></li>
            <li :class=" $route.path == '/Purchase' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('Purchase')">企业采购</a></li>
            <li :class=" $route.path == '/CompanyStock' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('CompanyStock')">企业仓库</a></li>
            <li :class=" $route.path == '/CompanySetting' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('CompanySetting')">企业设置</a></li>
            <li :class=" $route.path == '/WeChatApply' ? 'act' : ''"><a href="javascript:;" @click="JumpToPage('WeChatApply')">微信应用</a></li>
          </ul>
        </div>
        <div class="r">
          <div>联系我们</div>
          <ul>
            <li>电话：18516026677</li>
            <li>邮箱：Mike@teamrobotics.cn</li>
            <li>地址：昆山开发区杜鹃路555号C2栋</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="foot2">
      <!--<div>-->
        <!--<a href="javascript:;" style="color:#9ca6af;">-->
          <!--<img src="../../public/img/gh.png" style="vertical-align: middle;margin-bottom: 3px;">-->
          <!-- 闽公网安备 35021102000644号-->
        <!--</a>-->
      <!--</div>-->
      <!--<div>-->
        <!--© 2019 台源自动化-->
        <!--<a href="http://beian.miit.gov.cn" target="_blank" style="" class="BAN">-->
          <!--闽ICP备19026106号-1-->
        <!--</a>-->
      <!--</div>-->

      <div>
        <a href="javascript:;" style="color:#9ca6af;">
          <img src="../../public/img/gh.png" style="vertical-align: middle;margin-bottom: 3px;">
         {{police}}
        </a>
      </div>
      <div>
        © 2020 {{QYName}}，
        <a href="http://beian.miit.gov.cn" target="_blank" style="" class="BAN">
          <!--苏ICP备19007702号-->
          {{Domain}}
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data(){
    return{
      police:"",
      QYName:"",
      Domain:""
    }
  },
  props: {

  },
  methods:{
    JumpToPage(url){
      this.$router.push({
        path:"/" + url
      })
    }
  },
  mounted(){
    this.police = WebInfo.PoliceRecord;
    this.QYName = WebInfo.CompanyName;
    this.Domain = WebInfo.DomainNameFiling;
    //console.log(WebInfo)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.BAN{
  display: inline-block;color:#9ca6af;vertical-align: middle;margin-bottom: 4px;
}
</style>
